import * as React from 'react';
import * as SignalR from "@microsoft/signalr";
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { LoginUserActions } from 'redux/actions/LoginUserActions';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell, faUser } from '@fortawesome/free-regular-svg-icons'
import { faPowerOff, faWifi, faExclamationCircle, faChevronLeft, faBars, faTimes } from '@fortawesome/free-solid-svg-icons'
import { NavLink } from "react-router-dom";
import { StoreModel } from "models/StoreModel";
import { LoginUser } from 'models/LoginUser';
import Translator from '../common/Translator';
import { SignalRReiceiver } from "infrastructure/api/SignalRReceiver";
import { Tools } from 'infrastructure/tools';
import { NavMenuActions } from 'redux/actions/NavMenuActions';
require("../../../assets/img/logo-transparent-small.png");
require("../../../assets/img/favicon.ico");

interface IProps {
    loginUser: LoginUser;
    logOffAction: typeof LoginUserActions.logOffUser;
    fetchUserData: typeof LoginUserActions.fetchUserData;
    signalRDispatcher: Dispatch;
    toggleNavMenu: typeof NavMenuActions.toggleNavMenu;
    navMenuToggle: boolean;
    mobileNavMenuToggle: boolean;
}

interface IState {
    openMenu: string | undefined,
    connState: SignalR.HubConnectionState,
}

let signalR: SignalRReiceiver | undefined = undefined;
class TopBarComponent extends React.Component<IProps, IState> {
    public readonly state: IState = {
        openMenu: undefined,
        connState: SignalR.HubConnectionState.Connecting,
    }

    loggedIn() {
        return this.props.loginUser && this.props.loginUser.token;
    }

    getNotifications() {
        var notifications: React.JSX.Element[] = [];
        if (this.loggedIn() && this.props.loginUser.userData) {
            if (!(this.props.loginUser.userData.emailConfirmed)) {
                notifications.push(this.createConfirmEmailElement());
            }
        }
        return notifications;
    }

    createConfirmEmailElement() {
        return <Translator text="Please confirm your eMail address." />
    }

    componentDidMount() {
        if (this.loggedIn() && !this.props.loginUser.userData?.email) {
            this.props.fetchUserData(this.props.loginUser.token);
        }
        if (!signalR && this.loggedIn()) {
            signalR = new SignalRReiceiver(this.props.loginUser.token, this.props.signalRDispatcher);
        }
        // run loop to check for heartbeat failure and frequency activation
        this.backgroundTask();
    }

    // background task that performs all the periodically checks and actions
    async backgroundTask() {
        // let lastLogCleanup: Date = new Date(0);
        // let lastHistoryCleanup: Date = new Date(0);
        if (signalR && !signalR.isConnected()) {
            signalR.startConnection(this.props.loginUser.token)
        }
        while (true) { 
            await Tools.sleep(1000);
            if (this.loggedIn() && this.props.loginUser.userData && !this.props.loginUser.userData!.email) {
                this.props.fetchUserData(this.props.loginUser.token);
            } 
            if (signalR && !this.loggedIn()) {
                // logged off: drop the connection instead of renegotiating without a token
                signalR.stopConnection();
                signalR = undefined;
            }
            if (signalR) {
                const connState = signalR.getConnectionState();
                // console.log(signalR.getConnectionState())
                if (connState === SignalR.HubConnectionState.Disconnected) {
                    signalR.startConnection(this.props.loginUser.token)
                }
                if (this.state.connState !== signalR.getConnectionState()) {
                    this.setState(prevState => {
                        return {...prevState, connState: signalR!.getConnectionState()}
                    })
                }
            } else {
                if (!signalR && this.loggedIn()) {
                    signalR = new SignalRReiceiver(this.props.loginUser.token, this.props.signalRDispatcher);
                }
            }
        }
    }

    toggleMenu(menu: string, e?: React.MouseEvent) {
        if (e) {
            e.stopPropagation();
        };
        this.setState(prevState => {
            if (prevState.openMenu && prevState.openMenu === menu) {
                return { openMenu: undefined }
            }
            else return { openMenu: menu }
        });
    }

    toggleNavMenu() {
        this.props.toggleNavMenu()
    }

    logOff() {
        this.toggleMenu("account");
        this.props.logOffAction();
    }

    render() {
        const hasNotifications = this.getNotifications().length > 0;
        return (
            <header className="c-topbar">
                <button type="button" className="c-topbar__logo-box" onClick={() => this.toggleNavMenu()} aria-label="Toggle navigation">
                    <img src="/img/logo-transparent-small.png" alt="MOPS" />
                    <FontAwesomeIcon icon={this.props.navMenuToggle ? faChevronLeft : faBars} className="c-topbar__collapse--icon c-topbar__collapse--desktop" />
                    <FontAwesomeIcon icon={this.props.mobileNavMenuToggle ? faTimes : faBars} className="c-topbar__collapse--icon c-topbar__collapse--mobile" />
                </button>
                <div className="c-topbar__center" />
                <ul className="c-topbar__right">
                    {/* <li className="c-topbar__right-item">
                        <NavLink className="c-topbar__right--item-link" to={"/messages"}>
                            <FontAwesomeIcon icon={faEnvelope} className="c-topbar__right-item--icon" />
                        </NavLink>
                    </li> */}
                    <li className="c-topbar__right-item" onClick={(e) => this.toggleMenu("notifications", e)}>
                        <a>
                            <FontAwesomeIcon icon={faBell} className="c-topbar__right-item--icon"  />
                            {hasNotifications && 
                                <FontAwesomeIcon icon={faExclamationCircle} className="c-topbar__right-item--active"  />
                            }
                        </a>
                        {this.state.openMenu && this.state.openMenu === "notifications" && hasNotifications &&
                            <>
                                <div className="c-topbar__right-dropdown c-topbar__right-dropdown--notifications">
                                    {this.getNotifications().map((notification, idx) => {
                                        return (
                                            <React.Fragment key={idx}>
                                                <div className="c-notification">{notification}</div>
                                            </React.Fragment>
                                        )
                                    })}
                                </div>
                            </>
                        }
                    </li>

                    <li className="c-topbar__right-item" onClick={(e) => this.toggleMenu("account", e)}>
                        <FontAwesomeIcon icon={faUser} className="c-topbar__right-item--icon"  />
                        {this.state.openMenu && this.state.openMenu === "account" &&
                            <div className="c-topbar__right-dropdown">
                                <div className="c-topbar__right--item-link" onClick={() => this.logOff()}>
                                    <FontAwesomeIcon icon={faPowerOff} className="c-topbar__right-item--icon" />
                                    <span><Translator text="Logoff" /></span>
                                </div>
                                <NavLink className="c-topbar__right--item-link" to={"/account/details"} onClick={(e) => this.toggleMenu("account", e)}>
                                    <FontAwesomeIcon icon={faUser} className="c-topbar__right-item--icon" />
                                    <span><Translator text="My Profile" /></span>
                                </NavLink>
                            </div>
                        }
                    </li>

                    {/* <li className="c-topbar__right-item">
                        <FontAwesomeIcon icon={faCog} className="c-topbar__right-item--icon"></FontAwesomeIcon>
                    </li> */}
                    <li className="c-topbar__right-item">
                        {this.state.connState === SignalR.HubConnectionState.Connected &&
                            <FontAwesomeIcon icon={faWifi} className="c-topbar__right-item--icon c-topbar__right-item--icon-success"></FontAwesomeIcon>
                        }
                        {this.state.connState === SignalR.HubConnectionState.Connecting &&
                            <FontAwesomeIcon icon={faWifi} className="c-topbar__right-item--icon c-topbar__right-item--icon-warning c-topbar__right-item--pulse"></FontAwesomeIcon>
                        }
                        {this.state.connState !== SignalR.HubConnectionState.Connected && this.state.connState !== SignalR.HubConnectionState.Connecting &&
                            <FontAwesomeIcon icon={faWifi} className="c-topbar__right-item--icon c-topbar__right-item--icon-error"></FontAwesomeIcon>
                        }
                    </li>
                </ul>
            </header>
        );
    }
}

function mapStateToProps(state: StoreModel) {
    return {
        loginUser: state.loginUser,
        navMenuToggle: state.navMenuToggle,
        mobileNavMenuToggle: state.mobileNavMenuToggle
    };
}
function mapDispatchToProps(dispatch: Dispatch) {
    return {
        logOffAction: bindActionCreators(LoginUserActions.logOffUser, dispatch),
        fetchUserData: bindActionCreators(LoginUserActions.fetchUserData, dispatch),
        toggleNavMenu: bindActionCreators(NavMenuActions.toggleNavMenu, dispatch),
        signalRDispatcher: dispatch
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TopBarComponent);